import http from '@/libs/http'
import _ from 'lodash'
import { Exporter as ExcelExporter } from '@/libs/excelfile'
import moment from 'moment'

export function OrderRecover (orderId) {
  return http.post('zpchelper/orderrecover/', null, { params: { orderId } })
}

export function OpsRelease (orderItemId) {
  return http.post('zpchelper/opsrelease/', null, { params: { orderItemId } })
}

export function DetailOrder (orderId) {
  return http.get('crm/order/detail', { params: { id: orderId } }).then((resp) => {
    if (resp.deliveries && resp.deliveries.length) {
      resp.deliveries.forEach((pack) => {
        pack.images = pack.deliveryImages ? pack.deliveryImages.split(',') : []
      })
    }
    return resp
  })
}

export function ListOrder (queryModel) {
  return http.get('crm/order/list', { params: queryModel })
}

export function LoadOpsInfo (queryModel) {
  if (queryModel && queryModel.length) {
    return http.post('crm/order/opsinfo', queryModel)
  } else {
    return Promise.resolve([])
  }
}

export function LoadSourceInfo (orderItemIds) {
  if (orderItemIds && orderItemIds.length) {
    return http.post('crm/order/itemsource', orderItemIds)
  } else {
    return Promise.resolve([])
  }
}

export function LoadSourceInfoByOrderItem (orderItemId) {
  return http.get('crm/order/sourcedetail', { params: { orderItemId } })
}

/**
 * 出库详情
 * @param id
 */
export function DetailDelivery (id) {
  return http.get('crm/order/detaildelivery', { params: { id } })
}

/**
 * 发货的包裹信息
 * @param {*} id
 */
export function OrderItemDeliveryInfo (id) {
  return http.get('crm/order/itemdelivery', { params: { id } })
}

/**
 * 退款信息
 * @param {*} id
 */
export function OrderItemReturnInfo (id) {
  return http.get('crm/order/itemreturn', { params: { id } })
}

export function OrderItemStockInfo (orderIds) {
  return http.post('crm/order/stockinfos', orderIds)
}

export function AddTrackInfo (queryModel) {
  return http.post('crm/order/addtrackinfo', queryModel)
}

/**
 * 查询epc价格
 * @param {*} partInfos
 * @returns
 */
export function QueryPartCost4s (partInfos) {
  return http.post('crm/erp/querypriceinfo', partInfos)
}

export function QueryOEMInfo ({ brandCode, partCode }) {
  return http.get('crm/erp/queryoeminfo', { params: { brandCode, partCode } })
}

export function ListOrderAppy (queryModel) {
  return new Promise((resolve, reject) => {
    http.get('crm/order/applylist', { params: queryModel }).then((resp) => {
      const { items, pagination } = resp || {}
      if (items && items.length) {
        items.forEach((item) => {
          item.applyContext = JSON.parse(item.applyContext)
          item.companyName = item.applyContext.companyName
        })
        resolve(resp)
      } else {
        resolve({
          items: [],
          pagination
        })
      }
    })
  })
}

export function CreateOrderApply (contextData) {
  return http.post('crm/order/ordersubmit', JSON.stringify(contextData))
}

export function ListReceiverAddress (buyerId) {
  return http.get('crm/receiveraddress/querybybuyerid', { params: { buyerId } })
}

export function SearchBuyer (keyword) {
  return http.get('crm/receiveraddress/searchbuyer', { params: { keyword } })
}

export function UpdateAddress (queryModel) {
  return http.put('crm/receiveraddress/updateaddress', queryModel)
}

export function AddAddress (queryModel) {
  return http.post('crm/receiveraddress/addaddress', queryModel)
}

export function ToggleBatch (orderId) {
  return http.put(`crm/order/togglebatch?orderId=${orderId}`)
}

export const debounceToggleBatch = _.debounce((orderId) => { return ToggleBatch(orderId) }, 1000, {
  leading: true,
  trailing: false
})

export const ApplyState = [
  '待审核',
  '审核通过',
  '已生成订单',
  '审核未通过',
  '取消'
]

export function ListPackageOrder (queryModel) {
  return http.get('crm/order/listpackage', {
    params: queryModel
  })
}

export function ExportPakcageOrder (ids) {
  return http.post('crm/order/exportpackage', ids).then((resp) => {
    const mergeInfo = []
    const options = {
      '!cols': [
        { wpx: 120 },
        { wpx: 120 },
        { wpx: 100 },
        { wpx: 140 },
        { wpx: 140 },
        { wpx: 100 },
        { wpx: 100 },
        { wpx: 100 }
      ]
    }
    const exportData = []
    exportData.push(
      ['订单', '包裹', '出库时间', '品牌', '编号', '名称', '数量', '4S含税进价', '售价']
    )
    resp.forEach((item) => {
      exportData.push([
        { f: `"${item.orderSn}"` },
        `包裹${item.packageNum}`,
        moment(item.createTime).format('YYYY-MM-DD HH:mm'),
        item.brandName || item.brandCode,
        { f: `"${item.supersession || item.partCode}"` },
        item.partName,
        item.quantity,
        (+item.cost4S).toFixed(2),
        (+item.price).toFixed(2)
      ])
    })
    return ExcelExporter(
      exportData,
      mergeInfo,
      `出库记录_${moment().format('YYYYMMDDHHmmss')}.xlsx`,
      '出库记录',
      options
    )
  })
}

export function ExportOrder (orderInfo) {
  const mergeInfo = []
  const options = {
    '!cols': [
      { wpx: 60 }, // 品牌
      { wpx: 120 }, // sn
      { wpx: 140 }, // name
      { wpx: 120 }, // supersession
      { wpx: 40 }, // quality
      { wpx: 70 }, // warehouse
      { wpx: 50 }, // supportReturn
      { wpx: 40 }, // taxed
      { wpx: 60 }, // cost4s
      { wpx: 60 }, // price
      { wpx: 40 }, // quantity
      { wpx: 80 }, // coupon
      { wpx: 80 }, // reduction,
      { wpx: 80 }, // amount
      { wpx: 60 },
      { wpx: 60 },
      { wpx: 60 }
    ]
  }
  const exportData = []
  exportData.push(
    [ '品牌', '编号', '名称', '替换号', '品质', '仓库', '售后', '是否含税', '4S进价', '单价', '数量', '优惠券优惠', '满减优惠', '小计', '已发数量', '已退数量', '待发数量' ]
  )
  orderInfo.orderItems.forEach(oi => {
    exportData.push([
      oi.brandName,
      { f: `"${oi.partCode}"` },
      oi.partName,
      { f: `"${oi.supersession || ''}"` },
      oi.quality,
      oi.warehouse,
      oi.supportReturn ? '支持' : '不支持',
      oi.taxed ? '含税' : '税前',
      oi.cost4S,
      oi.price,
      oi.quantity,
      oi.couponAmount,
      oi.reductionAmount,
      +(oi.price * oi.quantity - oi.couponAmount - oi.reductionAmount).toFixed(2),
      oi.quantityDelivered,
      oi.quantityReturn,
      oi.quantity - oi.quantityReturn - oi.quantityDelivered
    ])
  })
  return ExcelExporter(
    exportData,
    mergeInfo,
    `订单${orderInfo.sn}.xlsx`,
    '订单明细',
    options
  )
}

export function ListRefund (queryModel) {
  return http.get('crm/order/refundlist', { params: queryModel })
}

export function UmsPlaceOrder (order) {
  return http.post('umspayment/qrcode/placeorder', {
    orderInfos: [
      {
        orderSn: order.sn,
        orderType: 2
      }
    ]
  })
}

export function TriggerApproval (query) {
  return http.post('crm/corpwechatquery/triggerapproval', query)
}

export function ListCredit (query) {
  return http.get('crm/credit/list', { params: query })
}

export function DetailCredit (id) {
  return http.get('crm/credit/detail', { params: { id } })
}

export function ListCreditBill (query) {
  return http.get('crm/credit/bill/list', { params: query })
}
